import { rem } from 'polished';
import styled from 'styled-components';

import { slate } from '@vimeo/iris/color';
import { ChevronDown } from '@vimeo/iris/icons';

const ChevronIcon = styled(ChevronDown)`
  width: ${rem(16)};
  height: ${rem(16)};
  margin-top: ${rem(2)};
  &:hover {
    path {
      fill: ${slate(800)};
    }
  }
  path {
    fill: ${slate(200)};
  }
`;

export default ChevronIcon;
